import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import PageLayout from '../components/PageLayout';
import AnalyticsHub from '../components/AnalyticsHub';

const TicketClicksAnalyticsPage: React.FC = () => {
  const { token } = useAuth();

  return (
    <PageLayout title="Ticket Clicks Analytics">
      <AnalyticsHub
        token={token}
        title="Artist"
        metricType="artist"
        blurb="Artist popularity derived from ticket_click (and share_open) events in the nightly rollup. Raw ticket-click Dynamo rows are retired during dual-write; prefer GA / Athena for click streams."
      />
    </PageLayout>
  );
};

export default TicketClicksAnalyticsPage;
